import { RowSystemConfigDto } from "@/dtos";
import { SystemConfig } from "@/entities";
import { getPaymentMethodTypeOption } from "@/helpers/options";

export const formatRowSystemConfigDto = (systemConfigs: SystemConfig[]): RowSystemConfigDto[] => {
    return systemConfigs.map(x => {
        const row: RowSystemConfigDto = {
            ...x,
            active: x.is_active ? 'Activo' : 'Inactivo',
            payment_method_type_label: getPaymentMethodTypeOption(x.payment_method_type).label,
            fare_type_label: x.fare_type?.name,
            time_label: x.time + " seg"
        }

        return row;
    });
}